import * as omnimap from "../../../../api/omnimap/omnimapActions";
import {GetSelected} from "../../tableHandler/manipulateTable";
import {FeatureListenerCallback} from "../../storageListener/featureListener";
import {toast} from "react-toastify";

export function GetDataForMapWithSetSelectedCallback(model, pageName) {
    const locations = [];
    const highlightedIds = [];

    omnimap
        .GetDataForMapAction(model, window.$mm_management_units_token)
        .then((result) => {
            if (result.data.length > 0) {
                const selectedIds = GetSelected()

                for (const data of result.data) {
                    locations.push(data.location);
                    if (selectedIds.includes(data.identification)) {
                        if (!data.location || !data.location.features){
                            toast.error(`Geselecteerd object (${data.content['algemeen-gisratio']}) heeft geen laaginformatie`)
                        } else {
                            for (let i = 0; i < data.location.features.length; i++) {
                                highlightedIds.push(
                                    data.location.features[i].properties.identifier
                                );
                            }
                        }
                    }
                }
                if (!window.$show_on_map_webgisId || window.$show_on_map_webgisId === "" ||  typeof window.$show_on_map_webgisId !== "string") {
                    window.$show_on_map_webgisId = uuidv4();
                    window.open(
                        "/gispublisher.html?webgisId=" +
                        window.$show_on_map_webgisId,
                        "_blank"
                    );

                    localStorage.setItem(
                        "webgis",
                        JSON.stringify({
                            type: "addFeatures",
                            locations: locations,
                            featureIds: highlightedIds,
                        })
                    );
                } else {
                    localStorage.setItem("webgis", "");
                    localStorage.setItem("webgis",
                        JSON.stringify({
                            type: "addFeatures",
                            locations: locations,
                            featureIds: highlightedIds,
                        })
                    );
                }
            }
        });

    return FeatureListenerCallback(undefined, (rows) => {
        window.$set_selected_button_selected_ids = rows;
    }, pageName)
}

function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}